import { Link } from 'react-router-dom';
import { navLinksLeft } from '../../constants/navigation';
import { TbMenu } from "react-icons/tb";

const Header = ({ onToggleMenu }) => {
  return (
    <header className="fixed top-0 left-0 right-0 z-40 bg-[#f9f9f5] px-4 sm:px-6 md:px-8 lg:px-12 xl:px-[54px] py-4 md:py-5 xl:py-0 xl:h-[103px] h-[54px] flex items-center">
      <div className="w-full relative flex items-center justify-between tracking-[0em] leading-[1.6] font-normal text-black min-h-[44px]">

        <nav className="hidden md:flex items-center space-x-2 md:space-x-3 lg:space-x-5 xl:space-x-6 flex-1">
          {navLinksLeft.map((link) => (
            <Link
              key={link.name}
              to={link.href}
              className="text-[12px] md:text-[13px] lg:text-[14px] leading-[1.6] tracking-[0em] hover:text-[#8C8275] transition-colors whitespace-nowrap"
            >
              {link.name}
            </Link>
          ))}
        </nav>

        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center justify-center cursor-pointer select-none">
          <Link to="/" className="flex flex-col items-center justify-center">
            <h1 className="font-saolDisplayItalic text-[32px] md:text-[28px] lg:text-[34px] xl:text-[36px] font-normal leading-none tracking-[0.02em]">
              SEASALT
            </h1>
            <span className="font-saolDisplayItalic text-[8px] md:text-[10px] tracking-[0.38em] uppercase text-[#666666] font-sans font-black leading-none mt-[3px] md:mt-[4px]">
              CREATIVE
            </span>
          </Link>
        </div>

        <div className="flex items-center space-x-4 md:space-x-5 lg:space-x-8 text-[14px] tracking-wide text-[#2B2B2B] flex-1 justify-end">
          {/* <Link
            to="/blog"
            className="font-inter-display-medium font-normal text-[13px] lg:text-[14px] leading-[1.6] tracking-[0em] hover:text-[#8C8275] transition-colors whitespace-nowrap hidden md:flex items-center"
          >
            Blog
          </Link> */}

          <Link
            to="/inquiry"
            className="font-EthicNewLightItalic font-black text-[13px] lg:text-[14px] leading-[1.6] tracking-[0em] hover:text-[#8C8275] transition-colors whitespace-nowrap hidden md:flex items-center border-b border-[#07070740]"
          >
            Inquire
          </Link>

          <button
            aria-label="Toggle Menu"
            onClick={onToggleMenu}
            className="group flex items-center justify-center focus:outline-none cursor-pointer text-[#1A1A1A] hover:text-[#8C8275] transition-colors"
          >
            <TbMenu className="w-6 h-6 md:w-7 md:h-7" />
          </button>
        </div>

      </div>
    </header>
  );
};

export default Header;
